import { commonViewTexts } from './common';
import { dialogViewTexts } from './dialogs';
import { notFoundMessages } from './others/not-found-messages';
import { pathDisplayName } from './others/path-display-name';
import { undeletableReasonViewTexts } from './others/undeletable-reason';
import { pagesViewTexts } from './pages';

export const viewTexts = {
  notFoundMessages,
  undeletableReason: undeletableReasonViewTexts,
  pathDisplayName: pathDisplayName,
  emptyPathElem: 'ー',
  appbar: {
    koumutenList: `${commonViewTexts.koumuten}一覧`,
    userList: `${commonViewTexts.user}一覧`,
    csvList: `${commonViewTexts.csv}一覧`,
    logout: 'ログアウト'
  },
  breadcrumbs: {
    home: 'Home'
  },
  dialogs: dialogViewTexts,
  pages: pagesViewTexts,
  stringLengthCheckMessageTargetName: {
    inferenceModel: commonViewTexts.model,
    projectName: `${commonViewTexts.project}名`,
    userName: `${commonViewTexts.user}名`,
    emailAddress: commonViewTexts.emailAddress,
    password: commonViewTexts.password,
    companyName: `${commonViewTexts.company}名`,
    koumutenName: `${commonViewTexts.koumuten}名`,
    imageName: `${commonViewTexts.blueprint}名`
  },
  labelCountResult: {
    name: 'ラベル',
    count: '個数'
  },
  annotationLabels:{
    name: 'ラベル',
    count: 'アノテーション数'
  },
  others: {
    delete: commonViewTexts.delete,
    cancel: commonViewTexts.cancel,
    instantDelete: commonViewTexts.instantDelete
  },
  tokenExpiredMessage: 'トークンが期限切れです',
  loadingMessage: '読み込み中…',
  tusUploader: {
    noParallelUpload: 'アップロード中にファイルを追加することはできません',
    numUploadFileRestriction: '一度にアップロードできるのは1ファイルまでです',
    jpegError: 'JPEG形式の画像には対応していません',
    otherFiletypeError: '対応していないファイル形式です',
    otherError: 'アップロード中にエラーが発生しました'
  },
  form: {
    stringLengthCheckMessage: (targetName: string, min: number, max: number) =>
      `${targetName}の長さは${min}～${max}にする必要があります。`,
    requiredCheckMessage: (targetName: string) =>
      `${targetName}は必須項目です。`
  },
  table: {
    pagination: {
      labelRowsPerPage: '1ページあたりの表示件数：',
      nextPageTooltip: '次のページ',
      prevPageTooltip: '前のページ',
      labelDisplayedRows: (from: number, to: number, numRows: number) =>
        `全${numRows}件中${from}～${to}件目を表示`
    }
  }
} as const;
